import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('NewsList').create(() => ({
  root: {
    width: '100vw',
    overflowX: 'hidden',
    overflowY: 'hidden',
    minHeight: '120px',
  },

  swiperSlide: {
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
